import React, { useState } from 'react';
import './TuringMachineDocsDetailed.css';
import { OverviewSection, CAFoundationSection, TMFoundationSection, LogicGatesSection, CircuitsSection, BusyBeaverSection, ApplicationsSection, AdvantagesSection, RevolutionSection, SummarySection } from './TMDocsComponents';

type Category = 'overview' | 'ca-foundation' | 'tm-foundation' | 'logic-gates' | 'circuits' | 'busy-beaver' | 'applications' | 'advantages' | 'revolution' | 'summary';

const TuringMachineDocsDetailed: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<Category>('overview');

  const categories = [
    { id: 'overview' as Category, label: 'Overview', icon: '📋' },
    { id: 'ca-foundation' as Category, label: 'CA Foundation Tests', icon: '🔬' },
    { id: 'tm-foundation' as Category, label: 'TM Foundation Tests', icon: '⚙️' },
    { id: 'logic-gates' as Category, label: 'Logic Gates', icon: '🔌' },
    { id: 'circuits' as Category, label: 'Advanced Circuits', icon: '🔧' },
    { id: 'busy-beaver' as Category, label: 'Busy Beaver Machines', icon: '🏆' },
    { id: 'applications' as Category, label: 'Applications & Vision', icon: '🚀' },
    { id: 'advantages' as Category, label: 'Technical Advantages', icon: '⚡' },
    { id: 'revolution' as Category, label: 'Computational Revolution', icon: '🌟' },
    { id: 'summary' as Category, label: 'Summary', icon: '📊' }
  ];

  return (
    <div className="tm-docs-detailed">
      <header className="docs-header">
        <h1>Symmetry CA Verification Report</h1>
        <p className="subtitle">Comprehensive Analysis with Detailed Test Verification</p>
        <div className="status-badges">
          <span className="badge success">✅ 97/97 Tests Passing (100%)</span>
          <span className="badge info">TURING COMPLETE</span>
        </div>
      </header>

      <nav className="category-nav">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`nav-item ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.id)}
          >
            <span className="nav-icon">{cat.icon}</span>
            <span className="nav-label">{cat.label}</span>
          </button>
        ))}
      </nav>

      <main className="docs-content">
        {activeCategory === 'overview' && <OverviewSection />}
        {activeCategory === 'ca-foundation' && <CAFoundationSection />}
        {activeCategory === 'tm-foundation' && <TMFoundationSection />}
        {activeCategory === 'logic-gates' && <LogicGatesSection />}
        {activeCategory === 'circuits' && <CircuitsSection />}
        {activeCategory === 'busy-beaver' && <BusyBeaverSection />}
        {activeCategory === 'applications' && <ApplicationsSection />}
        {activeCategory === 'advantages' && <AdvantagesSection />}
        {activeCategory === 'revolution' && <RevolutionSection />}
        {activeCategory === 'summary' && <SummarySection />}
      </main>
    </div>
  );
};

export default TuringMachineDocsDetailed;
